/**
 * Created by jbz on 2017/4/17.
 */
import {JNetworkConfig} from 'jbzwebsdk';
import GlobalConstant from '../util/GlobalConstant';
import DataMap from '../sdkConfig/icbc.network.unify';
import UrlMap from '../sdkConfig/icbc.url.config';

export default class Network {
  static createNetwork(vue) {
    let baseUrl = GlobalConstant.baseUrl;
    let timeout = GlobalConstant.timeout;
    let host = window.location.host;
    console.log(host);
    console.log(baseUrl)
    JNetworkConfig.setConfig({
      baseUrl,
      timeout,
      delegate: this,
      inType: 'CEBBANK-APP',
      dataMap:DataMap,
      urlMap:UrlMap
    })
  }

  static globalParas = () => {
    return {
      openId: GlobalConstant.store.state.AccountModule.account
    };
  }
}

